import { render, staticRenderFns } from "./optionItemImg.vue?vue&type=template&id=b07aa690&scoped=true"
import script from "./optionItemImg.vue?vue&type=script&lang=js"
export * from "./optionItemImg.vue?vue&type=script&lang=js"
import style0 from "./optionItemImg.vue?vue&type=style&index=0&id=b07aa690&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b07aa690",
  null
  
)

export default component.exports